import { Icon } from "components/lib";
import React from "react";

const RenameDialog = ({ closeDialog, action, loading, value, onChange, currentName }) => {
  return (
    <div className="fixed z-[100] overflow-y-auto top-0 w-full left-0">
      <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity flex items-center justify-center">
          <div
            className="absolute inset-0 bg-gray-900 opacity-75"
            onClick={closeDialog}
          />

          <div
            className="inline-block align-center bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[398px] sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="dark:bg-slate-800 bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="text-center">
                <h5 className="text-[32px] text-[#00147E] dark:text-white mb-6">
                  Rename
                </h5>
                {currentName && (
                  <p className="text-black text-[16px] leading-normal dark:text-white/70 mb-4">
                    Renaming <span className="font-medium">{currentName}</span>
                  </p>
                )}
                <input
                  type="text"
                  autoFocus
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && value?.trim()) action();
                  }}
                  placeholder="New map name"
                  className="w-full mb-2 px-4 py-3 rounded-[10px] border border-[#605BFF] bg-transparent text-[16px] text-black dark:text-white placeholder:text-[#8D9299] focus:outline-none focus:ring-0"
                />
              </div>

              <div className="py-3 flex">
                <button
                  type="button"
                  className="py-4 w-full px-10 border border-[#605BFF] text-[14px] text-[#605BFF] rounded-[10px] font-medium hover:bg-[#605BFF] hover:text-white mr-5 transition duration-500"
                  onClick={closeDialog}
                >
                  Back
                </button>
                <button
                  type="button"
                  disabled={!value?.trim() || loading}
                  className="relative py-4 w-full px-10 bg-[#605BFF] text-[14px] text-white rounded-[10px] border border-[#605BFF] font-medium hover:bg-opacity-80 transition duration-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={action}
                >
                  {loading ? (
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inline-block">
                      <Icon
                        name="loader-circle"
                        size={24}
                        fill="transparent"
                        color="#fff"
                        className="animate-spin flex-none"
                      />
                    </div>
                  ) : (
                    "Rename"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenameDialog;
